import script from "./device-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./device-info.vue?vue&type=script&setup=true&lang=ts"

import "./device-info.vue?vue&type=style&index=0&id=0da92992&lang=scss"

const __exports__ = script;

export default __exports__